/* eslint-disable react/prop-types */
import React from "react";
import { useNavigate } from "react-router-dom";
// import { Button } from "@toorak/op-web-tw-component";
import Error from "../../images/Error.svg";
import { RotateCcw } from "lucide-react";

export const CustomError = ({
  title = "Something Went Wrong!",
  message = "We're experiencing a temporary issue.",
  subMessage = "Please try again in a moment.",
}) => {
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate("/");
  };

  return (
    <div
      className="bg-[#f5f3f0] flex items-center justify-center p-4"
      style={{ minHeight: "calc(100vh - 72px" }}
    >
      <div className="text-center max-w-md mx-auto">
        {/* Error Illustration */}
        <div className="mb-8 flex justify-center">
          <Error className="mx-auto w-40 h-40" />
        </div>

        {/* Error Content */}
        <div className="space-y-4">
          <h1 className="text-2xl font-bold text-gray-800">{title}</h1>

          <div className="space-y-1">
            <p className="text-gray-600 text-base">{message}</p>
            <p className="text-gray-600 text-base">{subMessage}</p>
          </div>

          {/* Retry Button */}
          <div className="pt-4">
            <button
              type="button"
              onClick={handleRetry}
              className="bg-[#927940] hover:bg-[#8f6b47] text-white px-6 py-2 rounded-md font-medium transition-colors duration-200 flex items-center gap-2 mx-auto"
            >
              <RotateCcw className="w-4 h-4" />
              Retry
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
